exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accessRecords_sle{background:#24354c!important;color:#fff!important}.accessRecords_sle .el-select-dropdown__item.hover{background-color:rgba(64,158,255,.2)!important}.accessRecords_sle .el-select-dropdown__item{color:#fff!important}", ""]);

// exports
